import { websocketSchemas } from "@smart/bridge-resources-basic";
import { useWebsocket } from "@smart/itops-hooks-dom";
import { toSubdomain } from "@smart/itops-utils-basic";

export const manageVoiceWebsocket = useWebsocket(
  // Hardcode the prefix and lambda keys so we don't import Intake packages
  "ws",
  ["voiceConversationWebSocket"],
  websocketSchemas,
  { baseUrl: toSubdomain(undefined) }, // This will be the Intake base url
);
